export const navItems = [
  {
    id: 1,
    name: "Quiénes somos",
    href: "#quienessomos",
    section: "quienessomos",
  },
  {
    id: 2,
    name: "Nuestros productos",
    href: "#productos",
    section: "productos",
  },
  {
    id: 3,
    name: "Dónde encontrarnos",
    href: "#ubicacion",
    section: "ubicacion",
  },
  {
    id: 4,
    name: "Preguntas frecuentes",
    href: "#preguntas",
    section: "preguntas",
  },
];
